export const HORIZONTAL_SCROLL_EVENT = 'horizontalScroll';
export const LOAD_EVENT_TYPE = 'horizontal-scroll-load';
export const PROGRESS_EVENT_TYPE = 'horizontal-scroll-progress';
export const HORIZONTAL_SCROLL_ITEM_TRACKING_LABEL_ATTRIBUTE = 'data-tracking-label';
export const HORIZONTAL_SCROLL_ITEM_IDENTIFIER_ATTRIBUTE = 'data-horizontal-scroll-item';
